export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/touchpoint-visible.a2ad3edf-b8906d.png";